export function useInnerHeight() {
  return ref('100vh')
}
